import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class HotStyle extends Vue {
  @Prop({ default: () => {} })
    value: DisplayHotStyleData;

  @Prop()
    disabled: boolean;

  data: DisplayHotStyleData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="hot-style">
        <p class="title">期刊页</p>
        <el-radio-group v-model={this.data.desc.qiKanShowType} disabled={this.disabled}>
          <el-radio label={1}>使用瀑布流</el-radio>
          <el-radio label={2}>使用大图</el-radio>
        </el-radio-group>
      </div>
    );
  }
}
